import http from '@core/fetch'

export default {
  // 代理品牌列表
  getCertificationList: body =>
    http('/hms/merchant/appApi/brandcert/auditDetail', {
      body
    }),

  // 品牌库列表
  getBrandList: body =>
    http('/hms/merchant/appApi/brandcert/brandList', {
      body,
      ignore: [null, undefined]
    }),

  addCertification: body =>
    http.post('/hms/merchant/appApi/brandcert/submitAudit', {
      body
    }),

  editCertification: body =>
    http.post('/hms/merchant/appApi/brandcert/modifyAudit', {
      body
    }),

  // 删除
  deleteCertification: body =>
    http('/hms/merchant/appApi/brandcert/delAudit', {
      body
    }),

  // 获取token
  getUploadToken: body =>
    http('/hms/mediacenter/appApi/media/token', {
      body
    }),

  getNameStatus: body =>
    http('/hms/merchant/appApi/brandcert/checkIsCert', {
      body
    })
}
